module.exports = __webpack_public_path__ + "media/images/icons/phone-9f2946c4a79db663a98b97ef5d714652.svg";